module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "medicine-edit"
  }, [_c('div', [_c('transition', {
    attrs: {
      "name": "notifyFade"
    }
  }, [(_vm.notify !== null) ? _c('div', {
    staticClass: "notify-message-parent"
  }, [_c('div', {
    staticClass: "notify-message"
  }, [_c('div', {
    staticClass: "alert alert-dismissible",
    class: {
      'alert-success': _vm.notify.success, 'alert-danger': _vm.notify.danger, 'alert-warning': _vm.notify.warning
    }
  }, [_c('a', {
    staticClass: "close",
    attrs: {
      "href": "#",
      "data-dismiss": "alert",
      "aria-label": "close",
      "title": "close"
    }
  }, [_vm._v("×")]), _c('p', {
    staticClass: "notify-msg"
  }, [_vm._v(_vm._s(_vm.$t(_vm.notify.message_i18n)))])])])]) : _vm._e()])], 1), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/medicines?keep=true"
    }
  }, [_vm._v(_vm._s(_vm.$t('Medicine List')))])], 1), _c('li', [(_vm.medicine !== null) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.goMedicinesDetail(_vm.medicine.attributes['medicine-id'])
      }
    }
  }, [_vm._v(_vm._s(_vm.medicine.attributes['medicine-name']))]) : _vm._e()]), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Edit Medicine')))])])]), (_vm.loading || !_vm.searchCallbackFlag) ? _c('div', {
    staticClass: "row margin-top"
  }, [_vm._m(0)]) : _vm._e(), (_vm.medicine !== null) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v(_vm._s(_vm.$t('medicines.medicine_name')))]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.medicine.attributes['medicine-name']))])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v(_vm._s(_vm.$t('medicines.outline')))]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.medicine.attributes['intro-text']))])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v(_vm._s(_vm.$t('medicines.side_effect')))]), _c('div', {
    staticClass: "col-sm-10"
  }, [(_vm.sideEffects) ? _c('p', _vm._l((_vm.sideEffects), function(se) {
    return _c('span', [_vm._v(_vm._s(se.attributes['comment']) + " " + _vm._s(_vm.getAgeText(se))), _c('br')])
  })) : _vm._e()])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v(_vm._s(_vm.$t('medicines.additional_comment')))]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.additionalComment),
      expression: "additionalComment"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "rows": "8",
      "maxlength": "65535"
    },
    domProps: {
      "value": _vm._s(_vm.additionalComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.additionalComment = $event.target.value
      }
    }
  })])])])])])]) : _vm._e(), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-4 col-sm-offset-8 text-right"
  }, [(_vm.isAdminOrPharmacist) ? [_c('a', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.updateAdditionalComment()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Save')))])]), (_vm.medicine !== null) ? _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.goMedicinesDetail(_vm.medicine.attributes['medicine-id'])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Cancel')))])]) : _vm._e()] : [(_vm.medicine !== null) ? _c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.goMedicinesDetail(_vm.medicine.attributes['medicine-id'])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Back')))])]) : _vm._e()]], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/loading.gif")
    }
  }), _c('p', [_vm._v("loading...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-32b29870!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/medicine-edit.pug
// module id = 372
// module chunks = 1